<template>
    <div class="detailde_content">
        <div class="detailde_warp">
            <div class="detailde_warp_top">
                <div class="detailde_title" @click.stop="bShowTab = !bShowTab">
                    {{sSelectName}}
                    <!-- 订单选择 -->
                    <transition name="result-transform" mode="out-in">
                        <div class="detailde_seach" v-show="bShowTab">
                            <div :class="[nSeacth == index?'atv_detail':'']" v-for="(item,index) in arrSeacth" :key="index" @click="getClickTab(index)">{{item.name}}</div>
                        </div>
                    </transition>
                </div>
                <div class="result-tab-wrap">
                    <!-- 已完成 未完成 -->
                    <div :class="['result-tab-item', curTab === index && 'result-tab-item-act']" v-for="(item, index) in tabList" :key="index" @click="getCurTab(index)">{{ item.name }}</div>
                </div>
            </div>
            <div class="seach">
                <div class="seach_input">
                    <input type="text" placeholder="输入搜索内容" v-model="sSeach">
                    <div class="seach_img" @click="seach">
                        <img src="~@/assets/images/pagin/sarch_icon.png" alt="">
                    </div>
                </div>
            </div>
        </div>
        <!-- 列表 -->
        <div class="detailde_list">
            <div class="detailde_item" v-for="(detaitem,detaindex) in arrProject" :key="detaindex">
                <div class="detailde_item_top">
                    <div class="detailde_item_title">
                        {{detaitem.new_name}}
                    </div>
                    <div class="develop" @click="getDetailde(detaindex)">
                        {{detaitem.open?'收起':'展开'}}
                        <img :style="{'transform': detaitem.open?'rotate(-180deg)':'rotate(0deg)'}" src="~@/assets/images/pagin/send_down_icon.png" alt="">
                    </div>
                </div>
                <div class="detailde_item_content">
                    <div class="percentage_left user_detail">客户：{{detaitem.name}}</div>
                    <div class="percentage_right user_num">项目金融：{{detaitem.money}}元</div>
                </div>
                <div class="detailde_item_content detailde_item_bottom">
                    <div class="percentage_left">签单手：{{detaitem.sign_name}}</div>
                    <div class="percentage_right">项目经理：{{detaitem.pm_name}}</div>
                </div>
                <transition name="result-transform" mode="out-in">
                    <div v-show="detaitem.open">
                        <div class="detailde_item_content detailde_item_bottom">
                            <div class="percentage_left">项目号：{{detaitem.detailData ? detaitem.detailData.no :""}}</div>
                            <div class="percentage_right">项目阶段：{{detaitem.detailData ? detaitem.detailData.project_step :""}}</div>
                        </div>
                        <div class="detailde_item_content detailde_item_bottom">
                            <div class="percentage_left">客户来源：{{detaitem.detailData ? detaitem.detailData.source :""}}</div>
                            <div class="percentage_right">订单阶段：{{detaitem.detailData ? detaitem.detailData.order_step :""}}</div>
                        </div>
                        <div class="archives" v-if="detaitem.detailData ? detaitem.detailData.data.length ? true :false  :false">
                            <div class="archives_title">跟进档案</div>
                            <div class="archives_list" v-for="(item,index) in detaitem.detailData.data" :key="index">
                                <div class="archives_list_left">
                                    <div class="archives_list_label">
                                        {{item.name}}
                                    </div>
                                    <div class="archives_list_xian" v-if="index != detaitem.detailData.data.length - 1"></div>
                                </div>
                                <div class="archives_list_right">
                                    <!-- tab 图片上面的  -->
                                    <div class="archives_list_right_tab">
                                        <div :class="['archives_list_record']" :style="{'width':(100 / item.items.length) +'%'}" v-for="(sumitem,sumindex) in item.items" :key="sumindex">
                                            <div class="archives_list_xian" v-if="sumindex != 0"></div>
                                            <div :class="['archives_list_bef',sumitem.check?'finish_icon':'finish_icon_n']">
                                            </div>
                                            {{sumitem.name}}
                                        </div>
                                    </div>
                                    <!-- 图片 -->
                                    <div class="archives_list_right_plan">
                                        <div class="archives_plan_list" v-for="(sumitem,sumindex) in item.pics" :key="sumindex">
                                            <div class="archives_plan_url">
                                                <img :src="sumitem.url" alt="">
                                            </div>
                                            <div class="archives_plan_title">
                                                {{sumitem.name}}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </transition>
            </div>
        </div>
        <el-performance :nNumber="nTotal" @next="next" @last="last" @active="getActive" :bBackfoued="true"></el-performance>
    </div>
</template>

<script>
import elPerformance from "@/components/common/pagination/index.vue";
import oJourneyJs from "@/js/hvac/performance/user.js"

export default {
    components: {
        elPerformance,
    },
    created() {
        this.oSearchForm.agent = this.$route.query.agent;
        this.oSearchForm.area = this.$route.query.area;
        this.oSearchForm.channel = this.$route.query.channel;
        this.oSearchForm.city = this.$route.query.city;
        this.oSearchForm.worker = this.$route.query.worker;
        this.oSearchForm.start = this.$route.query.start;
        this.oSearchForm.end = this.$route.query.end;
        //console.log(this.$route)
        $init(() => {
            this.getJourneyProjectType()
        })
    },
    data() {
        return {
            bShowTab: false,
            tabList: [{ name: "已完成", type: "1" }, { name: "待完成", type: "0" }],
            curTab: 0,
            nSeacth: 0,
            arrSeacth: [
                // { name: "订单下达" },
                // { name: "订单解信" },
                // { name: "订单排产" },
                // { name: "订单发货" },
                // { name: "订单签收" },
                // { name: "设备安装" },
                // { name: "系统监理" },
                // { name: "设备调试" },
                // { name: "验收交付" },
            ],
            arrDetailde: [
                {
                    arrArchives: [
                        {
                            arrLabel: [
                                { name: "拜访签到", type: 1 },
                                { name: "初步接洽", type: 1 },
                                { name: "上门设计", type: 1 },
                                { name: "方案报价", type: 1 },
                                { name: "合同签订", type: 1 },
                            ],
                            arrPlan: [
                                { imgUrl: "", planName: "3D设计方案" },
                                { imgUrl: "", planName: "预算配置报表" },
                                { imgUrl: "", planName: "用户提案" },
                            ],
                        },
                        {
                            arrLabel: [
                                { name: "订单下达", type: 1 },
                                { name: "订单解信", type: 1 },
                                { name: "订单排产", type: 1 },
                                { name: "订单发货", type: 1 },
                                { name: "订单签收", type: 1 },
                            ],
                            arrPlan: [
                                { imgUrl: "", planName: "合同配" },
                                { imgUrl: "", planName: "生产计划" },
                                { imgUrl: "", planName: "物流轨迹" },
                            ],
                        },
                        {
                            arrLabel: [
                                { name: "设备安装", type: 1 },
                                { name: "系统监理", type: 0 },
                                { name: "设备调试", type: 0 },
                                { name: "交付验收", type: 0 },
                            ],
                            arrPlan: [{ imgUrl: "", planName: "项目案例" }],
                        },
                    ],
                    open: false,
                },
                {
                    arrArchives: [
                        {
                            arrLabel: [
                                { name: "拜访签到", type: 1 },
                                { name: "初步接洽", type: 1 },
                                { name: "上门设计", type: 1 },
                                { name: "方案报价", type: 1 },
                                { name: "合同签订", type: 1 },
                            ],
                            arrPlan: [
                                { imgUrl: "", planName: "3D设计方案" },
                                { imgUrl: "", planName: "预算配置报表" },
                                { imgUrl: "", planName: "用户提案" },
                            ],
                        },
                        {
                            arrLabel: [
                                { name: "订单下达", type: 1 },
                                { name: "订单解信", type: 1 },
                                { name: "订单排产", type: 1 },
                                { name: "订单发货", type: 1 },
                                { name: "订单签收", type: 1 },
                            ],
                            arrPlan: [
                                { imgUrl: "", planName: "合同配" },
                                { imgUrl: "", planName: "生产计划" },
                                { imgUrl: "", planName: "物流轨迹" },
                            ],
                        },
                        {
                            arrLabel: [
                                { name: "设备安装", type: 1 },
                                { name: "系统监理", type: 0 },
                                { name: "设备调试", type: 0 },
                                { name: "交付验收", type: 0 },
                            ],
                            arrPlan: [{ imgUrl: "", planName: "项目案例" }],
                        },
                    ],
                    open: false,
                },
                {
                    arrArchives: [
                        {
                            arrLabel: [
                                { name: "拜访签到", type: 1 },
                                { name: "初步接洽", type: 1 },
                                { name: "上门设计", type: 1 },
                                { name: "方案报价", type: 1 },
                                { name: "合同签订", type: 1 },
                            ],
                            arrPlan: [
                                { imgUrl: "", planName: "3D设计方案" },
                                { imgUrl: "", planName: "预算配置报表" },
                                { imgUrl: "", planName: "用户提案" },
                            ],
                        },
                        {
                            arrLabel: [
                                { name: "订单下达", type: 1 },
                                { name: "订单解信", type: 1 },
                                { name: "订单排产", type: 1 },
                                { name: "订单发货", type: 1 },
                                { name: "订单签收", type: 1 },
                            ],
                            arrPlan: [
                                { imgUrl: "", planName: "合同配" },
                                { imgUrl: "", planName: "生产计划" },
                                { imgUrl: "", planName: "物流轨迹" },
                            ],
                        },
                        {
                            arrLabel: [
                                { name: "设备安装", type: 1 },
                                { name: "系统监理", type: 0 },
                                { name: "设备调试", type: 0 },
                                { name: "交付验收", type: 0 },
                            ],
                            arrPlan: [{ imgUrl: "", planName: "项目案例" }],
                        },
                    ],
                    open: false,
                },
            ],
            //选中项的名字
            sSelectName: "",
            sSelectId: "",
            sStatus: "1",
            nPage: 1,
            nTotal: 0,
            arrProject: [],
            //订单详情
            //arrProjectDetail:[],
            //搜索表单
            oSearchForm: {
                //...
                agent: "",
                area: "",
                channel: "",
                city: "",
                worker: "",
                start: "",
                end: ""
            },
            sSeach:"",
        };
    },
    methods: {
        getDetailde(num) {
            let _that = this;
            if (!_that.arrProject[num].open) {
                //请求数据 塞进列表里面
                if (!_that.arrProject[num].detailData) {
                    this.getJourneyProjectDetail(num);
                } else {
                    _that.arrProject[num].open = !_that.arrProject[num].open;
                    this.$forceUpdate()
                }
            } else {
                _that.arrProject[num].open = !_that.arrProject[num].open;
                this.$forceUpdate()
            }
        },
        getClickTab(num) {
            let _that = this;
            if (this.nSeacth != num) {
                _that.nSeacth = num;
                let type = this.arrSeacth[num];
                this.sSelectName = type.name;
                this.sSelectId = type.type_id;
                this.getJourneyProject();
            }
        },
        getCurTab(num) {
            let _that = this;
            if (_that.curTab != num) {
                _that.curTab = num;
                this.sStatus = this.tabList[num].type;
                this.getJourneyProject();
            }
        },
        // 点击页数
        getActive(page) {
            //console.log(page)
            let _that = this;
            _that.nPage = page;
            _that.getJourneyProject();
        },
        // 上一页
        last(page) {
            let _that = this;
            _that.nPage = page;
            _that.getJourneyProject();
        },
        // 下一页
        next(page) {
            let _that = this;
            _that.nPage = page;
            _that.getJourneyProject();
        },
        //项目类型
        getJourneyProjectType() {
            oJourneyJs.getJourneyProjectType().then(res => {
                let result = res.data.data.result;
                this.arrSeacth = result;
                //默认第一项
                let type = this.arrSeacth[0];
                this.sSelectName = type.name;
                this.sSelectId = type.type_id;
                this.getJourneyProject();
            })
        },
        //获取项目清单
        getJourneyProject() {
            this.$store.commit("loadSwitch", true);
            let data = {
                type: this.sSelectId,
                status: this.sStatus,
                page: this.nPage,
                //搜索
                agent: this.oSearchForm.agent,
                area: this.oSearchForm.area,
                channel: this.oSearchForm.channel,
                city: this.oSearchForm.city,
                worker: this.oSearchForm.worker,
                start: this.oSearchForm.start,
                end: this.oSearchForm.end,
                keywords:this.sSeach,
            }
            oJourneyJs.getJourneyProject(data).then(res => {
                let result = res.data.data.result;
                this.nTotal = result.total_page;
                this.arrProject = result.list;
                this.$store.commit("loadSwitch", false);
            })
        },
        //获取项目详情
        getJourneyProjectDetail(index) {
            this.$store.commit("loadSwitch", true);
            let item = this.arrProject[index]
            let data = {
                pid: item.pid,
                //搜索
                agent: this.oSearchForm.agent,
                area: this.oSearchForm.area,
                channel: this.oSearchForm.channel,
                city: this.oSearchForm.city,
                worker: this.oSearchForm.worker,
                start: this.oSearchForm.start,
                end: this.oSearchForm.end,
               
            }
            oJourneyJs.getJourneyProjectDetail(data).then(res => {
                let result = res.data.data.result;
                item.detailData = result;
                item.open = true;
                //console.log(item)
                this.$forceUpdate()
                this.$store.commit("loadSwitch", false);
            })
        },
        seach(){
            if(!this.sSeach){
                this.$toast("请输入搜索内容")
                return
            }
            this.nPage=1;
            this.getJourneyProject(); 
        }
    },
};
</script>

<style lang="scss" scoped>
.result-transform-leave-active,
.result-transform-enter-active {
    transition: all 0.5s;
}
.result-transform-enter {
    opacity: 0;
    transform: translateY(-30px);
}
.result-transform-leave-to {
    opacity: 0;
    transform: translateY(-30px);
}
.detailde_content {
    position: absolute;
    width: 100%;
    min-height: 100%;
    background: #f5f5f5;
    top: 0;
    border-top: 1px solid #f7f7f7;
    .detailde_list {
        padding: 24px;
        box-sizing: border-box;
        .detailde_item {
            padding: 24px;
            box-sizing: border-box;
            border-radius: 12px;
            background: #fff;
            margin-top: 20px;
            &:first-child {
                margin-top: 0;
            }
            .detailde_item_top {
                display: flex;
                align-items: center;
                justify-content: space-between;
                width: 100%;
                padding-bottom: 20px;
                box-sizing: border-box;
                border-bottom: 1px dashed #f1f1f1;
                .detailde_item_title {
                    font-size: 28px;
                    font-weight: 700;
                    margin-right: 20px;
                    width: 82%;
                }
                .develop {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 28px;
                    img {
                        width: 26px;
                        height: 26px;
                        transition: all 0.5s;
                        margin-left: 10px;
                    }
                    // &::after {
                    //     content: "";
                    //     width: 26px;
                    //     height: 26px;
                    //     background: url("~@/assets/images/pagin/send_down_icon.png")
                    //         no-repeat center/100%;
                    // }
                }
            }
            .detailde_item_bottom {
                border-bottom: 1px dashed #f1f1f1;
                padding-bottom: 20px;
                box-sizing: border-box;
            }
            .detailde_item_content {
                display: flex;
                flex-wrap: wrap;
                .user_detail {
                    color: $deepGreen;
                    font-size: 28px;
                    font-weight: 700;
                }
                .user_num {
                    color: $deepGreen;
                    font-size: 28px;
                    font-weight: 700;
                }
                .percentage_left {
                    width: 55%;
                }
                .percentage_right {
                    width: 45%;
                }
                div {
                    margin-top: 22px;
                    font-size: 28px;
                    color: #858585;
                }
            }
            .archives {
                margin-top: 22px;
                .archives_title {
                    font-size: 28px;
                    font-weight: 700;
                }
                .archives_list {
                    margin-top: 22px;
                    display: flex;
                    .archives_list_left {
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        .archives_list_label {
                            width: 92px;
                            height: 36px;
                            background: $deepGreen;
                            border-radius: 18px;
                            color: #fff;
                            font-size: 24px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                        }
                        .archives_list_xian {
                            width: 1px;
                            background: $deepGreen;
                            height: 100%;
                            position: relative;
                            display: flex;
                            flex-direction: column;
                            align-items: center;
                            margin-top: 20px;
                            &::before {
                                content: "";
                                width: 20px;
                                height: 20px;
                                background: url("~@/assets/images/pagin/tip.png")
                                    no-repeat center/100% 100%;
                                position: absolute;
                                bottom: -3px;
                            }
                        }
                    }
                    .archives_list_right {
                        margin-left: 10px;
                        flex: 1;
                        .archives_list_right_tab {
                            width: 100%;
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            .archives_list_record {
                                display: flex;
                                justify-content: space-between;
                                flex-direction: column;
                                align-items: center;
                                position: relative;
                                .archives_list_xian {
                                    position: absolute;
                                    top: 18px;
                                    // bottom: 0;
                                    // margin: auto 0;
                                    left: calc(-50%);
                                    height: 1px;
                                    border-bottom: dashed 1px #c8e1ce;
                                    width: 100%;
                                    z-index: 0;
                                }
                                .archives_list_bef {
                                    margin-bottom: 10px;
                                    position: relative;
                                    z-index: 2;
                                }
                                .finish_icon {
                                    &::before {
                                        content: "";
                                        display: flex;
                                        width: 36px;
                                        height: 36px;
                                        background: url("~@/assets/images/pagin/finish_icon.png")
                                            no-repeat center/100% 100%;
                                    }
                                }
                                .finish_icon_n {
                                    &::before {
                                        content: "";
                                        display: flex;
                                        width: 36px;
                                        height: 36px;
                                        background: url("~@/assets/images/pagin/finish_icon_n.png")
                                            no-repeat center/100% 100%;
                                    }
                                }
                            }
                        }
                        .archives_list_right_plan {
                            display: flex;
                            align-items: center;
                            flex-wrap: wrap;
                            width: 100%;
                            .archives_plan_list {
                                margin-top: 20px;
                                display: flex;
                                align-items: center;
                                flex-direction: column;
                                width: 33.33%;
                                .archives_plan_url {
                                    width: 170px;
                                    height: 100px;
                                    background: #dfdfdf;
                                }
                                .archives_plan_title {
                                    text-align: center;
                                    color: #444444;
                                    font-size: 24px;
                                    margin-top: 10px;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
    .detailde_warp {
        width: 100%;
        // height: 218px;
        background: #fff;
        padding: 20px 24px 20px;
        box-sizing: border-box;
        .detailde_warp_top {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .detailde_title {
                font-size: 28px;
                color: #444444;
                display: flex;
                align-items: center;
                position: relative;
                &::after {
                    content: "";
                    display: inline-block;
                    width: 26px;
                    height: 26px;
                    margin-left: 10px;
                    background: url("~@/assets/images/pagin/send_down_two_icon.png")
                        no-repeat center/100%;
                }
                .detailde_seach {
                    position: absolute;
                    height: 736px;
                    bottom: -750px;
                    width: 208px;
                    background: #ffffff;
                    box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.1);
                    border-radius: 4px;
                    padding: 0 20px;
                    box-sizing: border-box;
                    overflow: auto;
                    div {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        height: 80px;
                        width: 100%;
                        font-size: 28px;
                        color: #858585;
                        &:last-child {
                            border: 0;
                        }
                    }
                    .atv_detail {
                        color: $deepGreen;
                        font-weight: 700;
                        border-bottom: 1px solid #f7f7f7;
                        &::before {
                            content: "";
                            position: absolute;
                            left: 6px;
                            width: 36px;
                            height: 36px;
                            background: url("~@/assets/images/pagin/sure.png")
                                no-repeat center/100% 100%;
                        }
                    }
                }
            }
            .result-tab-wrap {
                width: 252px;
                box-sizing: border-box;
                display: flex;
                flex-wrap: wrap;
                justify-content: space-between;
                align-items: center;
                background: #fff;
                border-radius: 8px;
                border: 2px solid $deepGreen;
                overflow: hidden;

                .result-tab-item {
                    width: 50%;
                    height: 64px;
                    font-size: 28px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: $deepGreen;
                    line-height: 64px;
                    text-align: center;
                    border-right: 2px solid $deepGreen;
                    &:last-child {
                        border: 0;
                    }
                }

                .result-tab-item-act {
                    background: $deepGreen;
                    color: #ffffff;
                    border: none;
                }
            }
            .develop {
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 28px;
                margin-top: 20px;
                &::after {
                    content: "";
                    width: 26px;
                    height: 26px;
                    background: url("~@/assets/images/pagin/send_down_icon.png")
                        no-repeat center/100%;
                }
            }
        }
        .seach {
            width: 100%;
            background: #fff;
            padding: 36px 0 0;
            box-sizing: border-box;
            .seach_input {
                width: 100%;
                height: 80px;
                background: #f7f7f7;
                border-radius: 12px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 0 24px;
                input {
                    width: 80%;
                    background: transparent;
                    height: 80px;
                    font-size: 28px;
                }
                .seach_img {
                    width: 40px;
                    height: 40px;
                    img {
                        width: 100%;
                        height: 100%;
                    }
                }
            }
        }
    }
}
</style>